<template lang="pug">
  div.lmm-content-body-padded
    b-container(fluid)
      b-row
        b-col.page-wrap(cols="12")
          div.page-header(slot="header")
            b-container.d-flex.justify-content-between(fluid, v-if="!AppState.isStandalone", style="padding-left: 0")
              div
                span.page-title {{$t('subscription')}}
              div
                b-btn(v-if="AppState.license !== 'Free'", variant="primary", size="sm", @click="addLicense", style='color: white') {{$t('add_n', {v: $t('license')})}}
                div(v-else) {{$t('free_trial_comment')}}
          b-card.table-card
            b-table.license-table(
              :fields="fields",
              :items="items",
              tbody-class="lmm-table-body")
              template(slot="HEAD_pay_start", slot-scope="data") {{$t('start_date')}}
              template(slot="HEAD_pay_expire", slot-scope="data") {{$t('end_time')}}
              template(slot="HEAD_pay_pay_type", slot-scope="data") {{$t('payment_type')}}
              template(slot="HEAD_pay_dev_vol", slot-scope="data") {{$t('device_vol')}}
              template(slot="HEAD_period", slot-scope="data") {{$t('remain')}}
              template(slot="HEAD_update", slot-scope="data") {{$t('renew')}}
              //- [임시] 글로벌 utcLocal 필터 도입 전까지 page 로컬 메서드 사용
              template(v-slot:cell(pay_start)="row")
                | {{asLocal(row.item.pay_start).format('YY-MM-DD')}}
              template(v-slot:cell(pay_expire)="row")
                | {{asLocal(row.item.pay_expire).format('YY-MM-DD')}}
              template(v-slot:cell(period)="row")
                template(v-if="row.item.isExpired") {{$t('expire')}}
                template(v-else) {{getFromNow(row.item.pay_expire)}}
              template(v-slot:cell(pay_type)="row")
                | {{$t(row.item.pay_type)}}
              template(v-slot:cell(update)="row")
                b-btn.update-license-btn(size="sm", @click="updateLicense(row.item)")
                  span {{$t('renew')}}
    b-modal(
      size="lg",
      v-model="payment.show",
      header-class="lmm-common-popup-header",
      no-close-on-backdrop,
      centered
    )
      template.align-items-center(slot="modal-header")
        //img.logo(:src="`${AppState.Path.image}/main_logo.png`")
        div
          h3.text-center {{$t(payment.title)}}
      div
        b-table.modal-table(
          :fields="payment.fields",
          :items="payment.items",
          tbody-class="lmm-table-body",
          outlined)
          template(slot="HEAD_start_date", slot-scope="data") {{$t('start_time')}}
          template(slot="HEAD_expire_date", slot-scope="data") {{$t('end_time')}}
          template(slot="HEAD_type", slot-scope="data") {{$t('device_type')}}
          template(slot="HEAD_vol", slot-scope="data") {{$t('device_vol')}}
          template(slot="HEAD_period", slot-scope="data") {{$t('period')}}
          template(slot="HEAD_total", slot-scope="data") {{$t('total_price')}}
          template(v-slot:cell(start_date)="row") {{row.item.start_date | moment('YY-MM-DD')}}
          template(v-slot:cell(expire_date)="row") {{row.item.expire_date | moment('YY-MM-DD')}}
          template(v-slot:cell(type)="row")
            template(v-if="useCustom") {{customPaymentName}}
            // 라이선스 추가할 때, type 이 베이직인 경우에만 코퍼레이트로 변경할 수 있고, 코레이트는 변경할 수 없도록 수정.
            // first 는 무료 체험으로 판단됨. ref 가 존재한다는 것은 갱신이라는 것이므로, 해당 조건으로 변경함.
            // 사장님 요청사항. 라이선스에 Basic 과 Corporate 타입이 둘 다 있으면, 라이선스 추가 시 제품 유형을 선택할 수 있도록 수정 (All 로 정의함)
            template(v-else-if="row.item.first || (!row.item.ref && ['All', 'Basic'].includes(AppState.license))")
              b-form-select(v-model="row.item.type", :options="[{value:'Corporate', text:$t('Corporate')},{value:'Basic', text:$t('Basic')}]", size="sm", @input="typeChanged(row.item)")
            template(v-else) {{$t(row.item.type)}}
          template(v-slot:cell(vol)="row")
            template(v-if="row.item.ref && !row.item.first") {{row.item.vol}}
            template(v-else)
              b-form-input.text-right(v-if="volInputFlag" v-model="row.item.vol", size="sm", @input="volChanged(row.item)")
              b-form-select(v-else v-model="row.item.vol", :options="vols", size="sm", @input="volChanged(row.item)")
          template(v-slot:cell(period)="row")
            b-form-select(v-model="row.item.period", :options="periods", size="sm", @input="calcTotal")
          template(v-slot:cell(total)="row")
            span.discount(v-if="payment.discount > 0") {{payment.fullPay | comma}} {{$t('WON')}}
            span.price {{payment.total | comma}} {{$t('WON')}}
        div(v-if="payment.title === 'regist_service'" ).d-flex.justify-content-center.flex-column.align-items-center.desc-div
          span.text-center.m-4(v-html="$t('payment_tax_desc3')")
        div(v-else).d-flex.justify-content-center.flex-column.align-items-center.desc-div
          div.text-center.mt-4(v-html="$t('payment_tax_desc4')")
          b-btn.mt-2(v-if="AppState.license !== 'Free'", variant="primary", size="sm", @click="addLicense", style='color: white') {{$t('add_n', {v: $t('license')})}}
          span.text-center.m-4(v-html="$t('payment_tax_desc3')")

      template(slot="modal-footer")
        b-btn(size="sm", @click="cancelPay") {{$t('cancel')}}
        b-btn(size="sm", variant="primary", @click="goPay") {{$t('payment')}}
    div.invisible(v-if="payment.show")
      form(:action="`${AppState.Path.pay}/payreq_crossplatform.php`", method="POST", ref="form", target="POPUPW")
        input(type="hidden", name="CST_PLATFORM" :value="AppState.paymentState")
        input(type="hidden", name="CST_MID" value="linkmemine")
        input(type="hidden", name="LGD_CUSTOM_FIRSTPAY" value="")
        input(type="hidden", name="LGD_WINDOW_TYPE" value="iframe")
        input(type="hidden", name="LGD_MERTKEY" value="1d41a901c46c00aabc52e7ba27db73ca")
        input(type="hidden", name="LGD_ENCODING_NOTEURL" value="UTF-8")
        input(type="hidden", name="LGD_WINDOW_TYPE" value="iframe")
        input(type="hidden", name="LGD_OID" :value="payment.timestamp")
        input(type="hidden", name="LGD_AMOUNT" :value="payment.total")
        input(type="hidden", name="CST_PLATFORM" :value="AppState.paymentState")
        input(type="hidden", name="LGD_BUYER" :value="user.name")
        input(type="hidden", name="LMM_BUYERID" :value="user.mgrid")
        input(type="hidden", name="LGD_PRODUCTINFO" :value="payment.items[0].type")
        input(type="hidden", name="LGD_BUYEREMAIL" :value="user.email")
        input(type="hidden", name="LGD_TIMESTAMP" :value="payment.timestamp")
        input(type="hidden", name="LMM_PC_COUNT" :value="payment.items[0].vol")
        input(type="hidden", name="LMM_PK" :value="user.pk")
        input(type="hidden", name="LMM_PRODUCTINFO" :value="payment.items[0].type")
        input(type="hidden", name="LMM_COMPANY_FK" :value="user.company_fk")
        //- [임시] 글로벌 utcLocal 필터 도입 전까지 page 로컬 메서드로 UTC + DISPLAY 둘 다 전송
        //- LMM_WARRANT_* = UTC naive (payres.php가 보정 없이 그대로 DB 적재)
        //- LMM_WARRANT_*_DISPLAY = 로컬 naive (payreq_crossplatform.php가 결제 확인 화면에 그대로 표시)
        input(type="hidden", name="LMM_WARRANT_START" :value="utcFormat(payment.items[0].start_date)")
        input(type="hidden", name="LMM_WARRANT_END" :value="utcFormat(payment.items[0].expire_date)")
        input(type="hidden", name="LMM_WARRANT_START_DISPLAY" :value="displayFormat(payment.items[0].start_date)")
        input(type="hidden", name="LMM_WARRANT_END_DISPLAY" :value="displayFormat(payment.items[0].expire_date)")
        input(type="hidden", name="LMM_UPDATE_PK" :value="payment.items[0].ref")
        input(type="hidden", name="LMM_TERM" :value="payment.items[0].period")
        input(type="hidden", name="LMM_PAY_FLAG" :value="payment.items[0].ref ? 1 : 0")
        input(v-if="useCustom", type="hidden", name="LMM_CUSTOM_PAYMENT" :value="customPaymentName")
</template>

<script>
import _ from 'lodash'
import moment from 'moment-timezone'
import {user, getUserData} from '../../api/access'

const typeValue = {
  Basic: 3850, // 정가 3800에 VAT 포함 적용
  Corporate: 4510 // 정가 4100에 VAT 포함 적용
}

export default {
  name: 'license-component',
  methods: {
    // ──────────────────────────────────────────────────────────
    // [임시] license 페이지 한정 시간 처리 헬퍼.
    // 백엔드 = UTC, 표시 = 사용자 OS 로컬 원칙.
    // 추후 main.js에 utcLocal 필터 글로벌 등록 시 이 5개 메서드 제거하고
    // 호출부도 `{{ value | utcLocal(fmt) }}` 형태로 일괄 단순화 예정.
    // ──────────────────────────────────────────────────────────
    // 백엔드 UTC 응답을 UTC moment로 (비교/계산용, 변환 없음)
    asUtc (d) {
      return moment.utc(d)
    },
    // 백엔드 UTC 응답을 사용자 로컬(KST 등)로 변환 (표시/전송용)
    asLocal (d) {
      return moment.utc(d).local()
    },
    // 만료까지 남은 기간 표시 (예: "3 months")
    getFromNow (d) {
      return this.asUtc(d).fromNow(true)
    },
    // 결제 폼 전송용: DB 적재할 UTC naive 문자열 (PHP는 보정 없이 그대로 INSERT)
    utcFormat (d) {
      return this.asUtc(d).format('YYYY-MM-DD HH:mm:ss')
    },
    // 결제 폼 전송용: 결제 확인 화면 표시할 로컬 naive 문자열
    displayFormat (d) {
      return this.asLocal(d).format('YYYY-MM-DD HH:mm:ss')
    },
    goPay () {
      this.payment.timestamp = new Date().getTime()
      this.paywin = window.open('about:blank', 'POPUPW', 'width=1024,height=726')
      this.$nextTick(() => { this.$refs.form.submit() })

      if (this.checker) clearInterval(this.checker)
      this.checker = setInterval(() => {
        if (this.paywin.closed) {
          clearInterval(this.checker)
          this.checker = null
          this.paywin = null

          getUserData(null, (err, userData) => {
            if (err) this.$log.error('[REFRESH USER DATA FAILED]')
            this.license = userData.license
            this.user = userData
            this.payment.show = false
            this.volInputFlag = false // 초기화
          })
        }
      }, 500)
    },
    cancelPay () {
      this.payment.show = false
      this.volInputFlag = false // 초기화
    },
    calcTotal () {
      if (!this.payment.items[0]) return 0
      let t = this.payment.items[0]
      
      // 사장님 요청사항. 라이선스에 Basic 과 Corporate 타입이 둘 다 있으면, 라이선스 추가 시 제품 유형을 선택할 수 있도록 수정 (All 로 정의함)
      if (t.type === 'All') {
        t.type = 'Corporate'
      }
      
      let vol = parseInt(t.vol, 10)
      let value = this.useCustom ? this.customPaymentPrice : typeValue[t.type]
      let total = vol * t.period * value
      let additional = Math.floor(t.period / 12)
      
      // 할인 로직, 1년 3% / 2년 5% / 3년 7%
      let discount = 0
      if (additional === 1) {
        discount = (0.03) * total
      } else if (additional === 2) {
        discount = (0.05) * total
      } else if (additional >= 3) {
        discount = (0.07) * total
      }
      
      this.payment.items[0].expire_date = moment(this.payment.items[0].start_date).add(t.period, 'M').format()
      this.payment.discount = discount
      this.payment.fullPay = Math.round(total)
      this.payment.total = Math.round(total - discount)
    },
    // calcTotal의 유연성 한계로 인해, 특정 로직을 처리하기 위해 volChanged와 typeChanged 메서드가 필요.
    volChanged (item) {
      // 사용자가 장치 수(vol)를 변경했을 때 호출되는 메서드
      if (Number(item.vol) === 0) { // 직접 입력
        this.volInputFlag = true
        this.typeChanged(item)
      }
      
      // 입력값 검증
      if (item.vol <= 0) { // 0 또는 음수일 경우
        this.$awn.warning(this.$t('invalid_data')) // 사용자에게 오류 메시지 표시
        item.vol = 1
      }
      
      this.payment.items[0].vol = item.vol
      this.calcTotal()
    },
    typeChanged (item) {
      // 직접 입력에 대한 vol 개수 초기화
      if (this.volInputFlag) {
        item.vol = 11
      }
      this.calcTotal();
    },
    addLicense () {
      // [임시] 변수 형식을 UTC로 통일 (updateLicense와 일관)
      const date = moment.utc()
      this.payment.title = 'regist_service'
      this.payment.items = [
        {
          ref: null,
          start_date: date.format(),
          expire_date: date.add(1, 'M').format(),
          type: this.license.total.primaryProdType,
          vol: 1,
          period: 1
        }
      ]
      this.calcTotal()
      this.payment.show = true
    },
    updateLicense (t) {
      const isFirst = t.pay_type === 'Free'
      // [임시] 백엔드 UTC를 정확히 UTC로 파싱.
      // 이전 moment(t.pay_expire)는 로컬로 잘못 해석해 -9h 손실 발생했음.
      // 변수 형식을 DB·PHP·백엔드와 동일한 UTC로 통일.
      let date = this.asUtc(t.pay_expire)
      if (moment().diff(date, 'seconds') > 0) date = moment()
      this.payment.title = 'update_service'
      this.payment.items = [
        {
          ref: t.pay_pk,
          start_date: date.format(),
          expire_date: date.add(1, 'M').format(),
          type: isFirst ? 'Corporate' : t.pay_type,
          vol: t.pay_dev_vol,
          period: 12,
          first: isFirst
        }
      ]
      this.calcTotal()
      this.payment.show = true
    }
  },
  beforeDestroy () {
    if (this.checker) {
      clearInterval(this.checker)
    }
    if (this.paywin && this.paywin.close) {
      this.paywin.close()
    }
  },
  data () {
    const userData = user()
    const useCustom = /.*?\|\d+/.test(userData.custom_payment)
    return {
      checker: null,
      paywin: null,
      fields: [
        {
          key: 'pay_start',
          label: this.$t('start_date'),
          tdClass: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'pay_expire',
          label: this.$t('expire_date'),
          tdClass: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'pay_type',
          label: this.$t('device_type'),
          tdClass: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'pay_dev_vol',
          label: this.$t('no_devices'),
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          key: 'period',
          label: this.$t('period'),
          tdClass: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'update',
          label: this.$t('renew'),
          tdClass: 'text-center',
          thClass: 'text-center'
        }
      ],
      license: userData.license,
      user: userData,
      useCustom: useCustom,
      customPaymentName: useCustom ? userData.custom_payment.split('|')[0] : null,
      customPaymentPrice: useCustom ? parseInt(userData.custom_payment.split('|')[1]) : null,
      payment: {
        show: false,
        timestamp: 0,
        discount: 0,
        fields: [
          {
            key: 'start_date',
            label: this.$t('start_date'),
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            key: 'expire_date',
            label: this.$t('expire_date'),
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            key: 'type',
            label: this.$t('device_type'),
            tdClass: 'text-center',
            thClass: 'text-center',
            thStyle: { width: "120px" },
          },
          {
            key: 'vol',
            label: this.$t('device'),
            tdClass: 'text-center',
            thClass: 'text-center',
            thStyle: { width: "120px" },
          },
          {
            key: 'period',
            label: this.$t('period'),
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            key: 'total',
            label: this.$t('total_price'),
            tdClass: 'text-center',
            thClass: 'text-center',
            thStyle: { minWidth: "200px" },
          }
        ],
        items: []
      },
      periods: [
        { value: 1, text: `1 ${this.$t('months')}` },
        { value: 2, text: `2 ${this.$t('months')}` },
        { value: 3, text: `3 ${this.$t('months')}` },
        { value: 4, text: `4 ${this.$t('months')}` },
        { value: 5, text: `5 ${this.$t('months')}` },
        { value: 6, text: `6 ${this.$t('months')}` },
        { value: 7, text: `7 ${this.$t('months')}` },
        { value: 8, text: `8 ${this.$t('months')}` },
        { value: 9, text: `9 ${this.$t('months')}` },
        { value: 10, text: `10 ${this.$t('months')}` },
        { value: 11, text: `11 ${this.$t('months')}` },
        { value: 12, text: `12 ${this.$t('months')}` },
        { value: 24, text: `2 ${this.$t('years')}` },
        { value: 36, text: `3 ${this.$t('years')}` },
        // { value: 48, text: `4 ${this.$t('years')}` },
        // { value: 60, text: `5 ${this.$t('years')}` }
      ],
      vols: {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        0: this.$t('manual_input'),
      },
      volInputFlag: false,
    }
  },
  computed: {
    items () {
      let list = this.license.list
      list.sort((a, b) => b.expireTimeStamp - a.expireTimeStamp)
      return _.map(list, v => {
        if (v.isExpired) v._rowVariant = 'active'
        return v
      })
    },
    today () {
      return moment().format()
    }
  }
}
</script>

<style lang="scss" scoped>
.lmm-content-body-padded {
  padding: 0;
  margin: 0;
}

.row, .col, .container-fluid {
  margin: 0;
  padding: 0;
}

.page-wrap {
  padding: 1rem 1.5rem;
}

.page-header {
  padding: 0 1.5rem 0 1.5rem;
  margin-bottom: 0.5rem;
}

.card {
  border-radius: 0;
  .card-body {
    padding: 0;
  }
}

.btn-secondary {
  color: black !important;
  background-color: #FFFFFF;
  font-weight: 400;
}

.btn-primary {
  color: black;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #F7F7F7 !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #CBCBCB !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

::v-deep .license-table {
  margin: 0;
  tr, td, th {
    padding: 0.5rem 1rem;
    position: relative;
    font-weight: 400;
  }
  th:nth-child(1), th:nth-child(2), th:nth-child(3), th:nth-child(4) {
    position: relative;
    padding-right: 0;
    text-align: left !important;
    width: 13% !important;
  }
  //th:nth-child(1)::after, th:nth-child(2)::after, th:nth-child(3)::after {
  //  content: "";
  //  position: absolute;
  //  right: 0;
  //  top: 50%;
  //  transform: translateY(-50%);
  //  height: 60%;
  //  border-right: 0.1rem solid #6F6F6F;
  //}
  td:nth-child(1), td:nth-child(2), td:nth-child(3), td:nth-child(4) {
    position: relative;
    padding-right: 0;
    text-align: left !important;
    color: #6F6F6F;
  }
}

h3 {
  color: #FFFFFF;
  margin-bottom: 0;
  font-weight: 250;
  font-size: 1.5rem;
}

.header-desc-div {
  font-size: 1.2rem;
  font-weight: bold;
}

.desc-div {
  color: #6F6F6F;
}

.discount {
  display: inline-block;
  padding-right: 10px;
  text-decoration: line-through;
  color: #afafaf;
}
</style>
